import React from "react";
import PropTypes from "prop-types";
import { icons } from "../../utils/icons";
import "./style.scss";

export default function BaseIcon({
  name,
  className,
  onClick,
  iconWrapperStyle,
}) {
  BaseIcon.propTypes = {
    name: PropTypes.string,
    className: PropTypes.string,
    iconWrapperStyle: PropTypes.string,
    onClick: PropTypes.func,
  };
  const Icon = icons[name];
  const iconWrapperCls = ["base-icon"];
  if (iconWrapperStyle) iconWrapperCls.push(iconWrapperStyle);
  // Неизвестное имя иконки не должно ронять всю страницу (белый экран) —
  // если в карте нет такого ключа, просто ничего не рендерим.
  return (
    <div className={iconWrapperCls.join(" ")}>
      {name && Icon && <Icon onClick={onClick} className={className} />}
    </div>
  );
}
